<template lang="pug">
  .order
    .order__body
      .order__alert Если Вы не видите в окне свою анкету,
        a(
          href='#'
          @click.prevent='reload'
        ) нажмите сюда
      a.order__cover(
        :href='document'
        target='_blank'
        @click.prevent='openModal'
      )
        Loader(v-if='loading')
        embed.order__document(
          :src="preview"
        )
        div.order__document--placeholder
    .order__footer
      .form__button
        button.order__button.button.is-large.print(
          @click="print"
        ) Печать
        br
        button.order__button.button.is-large.has-arrow(
          @click='clickHandler'
        ) Все верно, продолжить
</template>

<script>
import { mapActions } from "vuex";

export default {
  data() {
    return {
      loading: false
    };
  },
  props: {
    document: String
  },
  computed: {
    preview() {
      return `https://view.officeapps.live.com/op/embed.aspx?src=${process.env.VUE_APP_API_SERVER}${this.document}`;
    }
  },
  methods: {
    ...mapActions({
      setModalContent: "modal/set",
      setCompleted: "stages/setCompleted"
    }),
    openModal() {
      this.setModalContent(
        `<div style="position:relative;"><iframe src="${this.preview}" style="width:100%;height:80vh;border:none;"></iframe><div class="order__document--placeholder"></div></div>`
      );
    },
    clickHandler() {
      this.setCompleted("varification");
      this.$router.push("pay");
    },
    reload() {
      let embed = document.querySelector(".order__document");
      let newEmbed = document.createElement("embed");
      newEmbed.src = this.preview;
      newEmbed.classList.add("order__document");
      embed.parentElement.replaceChild(newEmbed, embed);
      this.loading = true;
      setTimeout(() => (this.loading = false), 500);
    },
    print() {
      window.open(
        `${process.env.VUE_APP_API_SERVER}${this.document}`,
        "_blank"
      );
    }
  }
};
</script>

<style lang="scss">
.order {
  display: flex;
  flex-direction: column;
  width: 100%;

  .loader {
    position: absolute;
  }

  &__body {
    flex-grow: 1;
    width: 100%;
  }

  &__cover {
    display: block;
    width: calc(100% + 36px);
    height: auto;
    margin: -18px;
    margin-bottom: 0;
    position: relative;
    z-index: 0;

    &::after {
      content: "";
      display: block;
      width: 64px;
      height: 64px;
      position: absolute;
      left: 30px;
      bottom: 40px;
      z-index: 1;
      border-radius: 14px;
      background-color: $accent;
      background-image: url(../img/zoom.svg);
      background-repeat: no-repeat;
      background-position: 50% 50%;
      background-size: 32px 33px;
      transition: ease background-color 200ms;
    }

    &:hover {
      &::after {
        background-color: lighten($accent, 10);
      }
    }
  }

  &__document {
    width: 100%;
    height: 100%;
    min-height: 840px;
    border: none;

    &--placeholder {
      position: absolute;
      bottom: 0;
      right: 0;
      width: 100%;
      height: 26px;
      background-color: #fff;
    }
  }

  &__footer {
    display: flex;
    justify-content: flex-end;
    flex-shrink: 0;
    margin-top: 30px;
  }

  &__alert {
    padding: 15px;
    padding-right: 15px;
    background-color: rgba(59, 122, 190, 0.2);
    border-radius: 14px;
    color: black;
    margin-bottom: 45px;
    a {
      color: $second;
    }
  }

  &__button {
  }
}
</style>
